import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Card, CardBody, CardHeader } from "reactstrap";

import { Btn, H4 } from "../../../../../AbstractElements";
import {
  ALL_COURSE_FILTER_STATUS,
  courseTypeMap,
  EXPERTISE_LEVEL_STATUS,
  ILT,
  PUBLISHED,
  STATUS_200,
  WEBINAR,
} from "../../../../../Api/constants";
import FixedFooter from "../../../../../CommonElements/FixedFooter";
import CommonModal from "../../../../../CommonElements/Modal";
import StatusDisplay from "../../../../../CommonElements/StatusDisplay";
import StepperHorizontal from "../../../../../CommonElements/StepperHorizontal";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../ReduxToolkit/Hooks";
import { getAssessmentCatlogList } from "../../../../../ReduxToolkit/Reducers/AssessmentCatlogSlice";
import { getCourseList } from "../../../../../ReduxToolkit/Reducers/CourseSlice";
import {
  handleBackButton,
  setNumberLevelForSteps,
  createLearningPlan,
  getLearningPlanById,
  updateLearningPlan,
  handlePlanNextButton,
} from "../../../../../ReduxToolkit/Reducers/LearningPlanMaster";
import {
  getDomainList,
  getFilterRolesList,
} from "../../../../../ReduxToolkit/Reducers/MasterSlice";
import { uploadFileApi } from "../../../../../ReduxToolkit/Reducers/UserSlice";
import {
  AddCourseAssessment,
  Assessment,
  Back,
  Close,
  Confirm,
  ConfirmCreateLearningPlanBody,
  ConfirmCreateLearningPlanHeader,
  Courses,
  CreateLearningPlan,
  DescriptionValidationMessage,
  DomainIsRequired,
  Done,
  DurationIsRequired,
  JobRoleIsRequired,
  LearningPlanNameRequired,
  ModifyLearningPlan,
  Next,
  PleaseProvideRequiredInformation,
  QuestionsTitle,
  ThumbnailRequired,
  TotalActivityDuration,
  VILT,
  WBT,
} from "../../../../../utils/Constant";
import {
  formatMinutes,
  extractFileName,
  learningPlanStepperData,
  scrollToTop,
  showToast,
  fileUrlKeys,
} from "../../../../../utils/helper/helper";

import AddCoursesOrAssessment from "./AddCourses";
import LearningPlanBasicDetails from "./BasicDetails";

const initialFormValues = {
  learning_plan_name: "",
  domain: [],
  job_role: [],
  duration: null,
  level: "",
  thumbnail_url: null,
  description: "",
  auto_assign: false,
  opt_in: false,
};

interface FormErrors {
  [key: string]: string;
}

const initialFormErrors: FormErrors = {};

const CreateLearningPlans = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { numberLevel, showFinish, learningPlanById } = useAppSelector(
    state => state.learningPlanMaster
  );
  const [jobRoleListData, setJobRoleListData] = useState([]);
  const [jobRoleListMap, setJobRoleListMap] = useState({});
  const [domainListMap, setDomainListMap] = useState({});
  const [courseListData, setCourseListData] = useState([]);
  const [courseListMap, setCourseListMap] = useState({});
  const [assesmentCatlogMap, setAssesmentCatlogMap] = useState({});
  const { courseList } = useAppSelector(state => state.course);
  const { assessmentCatlogList } = useAppSelector(
    state => state.assessmentCatlog
  );
  const { domainList, roleOnFilter } = useAppSelector(state => state.master);
  const [domainListData, setDomainListData] = useState([]);
  const [assesmentCatlog, setAssesmentCatlog] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [basicInputFormValue, setBasicInputFormValue] =
    useState(initialFormValues);
  const [errors, setErrors] = useState(initialFormErrors);
  const [courses, setCourses] = useState([]);
  const [assessments, setAssessments] = useState([]);
  const [preSelectedCoursesIds, setPreSelectedCoursesIds] = useState([]);
  const [preSelectedAssessmentIds, setPreSelectedAssessmentIds] = useState([]);
  const queryParams = new URLSearchParams(location.search);
  const learningPlanId = queryParams.get("id") || "";
  const domainId = queryParams.get("domain_id") || "";
  const pageType = queryParams.get("show") || "";

  useEffect(() => {
    setCourses([]);
    setAssessments([]);
    setPreSelectedCoursesIds([]);
    setPreSelectedAssessmentIds([]);
    setBasicInputFormValue(initialFormValues);
    setBasicInputFormValue(null);
  }, []);

  useEffect(() => {
    if (pageType === "people") {
      dispatch(setNumberLevelForSteps(2));
    } else {
      dispatch(setNumberLevelForSteps(1));
    }
  }, [pageType]);

  useEffect(() => {
    dispatch(getFilterRolesList());
    dispatch(getDomainList());
    dispatch(
      getCourseList({
        status: EXPERTISE_LEVEL_STATUS,
        course_type: ALL_COURSE_FILTER_STATUS,
        domain: null,
      })
    );

    dispatch(
      getAssessmentCatlogList({
        status: PUBLISHED,
        assessment_type: ["standalone"],
        tag: "",
      })
    );
  }, [dispatch, pageType, numberLevel]);

  useEffect(() => {
    const roles = [];
    const roleMap = {};
    roleOnFilter?.job_role?.forEach(element => {
      roleMap[element.id] = element.name;
      roles.push({
        name: element.id.toString(),
        value: element.name,
        label: element.name,
      });
    });
    setJobRoleListMap(roleMap);
    setJobRoleListData(roles);
  }, [roleOnFilter]);

  useEffect(() => {
    if (learningPlanId) {
      dispatch(getLearningPlanById({ id: learningPlanId }));
    }
  }, [dispatch, learningPlanId]);

  useEffect(() => {
    const domains = [];
    const domainsMap = {};
    domainList?.domain?.forEach(element => {
      domainsMap[element.id] = element.domain_name;
      domains.push({
        name: element.id.toString(),
        value: element.domain_name,
        label: element.domain_name,
      });
    });
    setDomainListMap(domainsMap);
    setDomainListData(domains);
  }, [domainList]);

  useEffect(() => {
    const publishedCourse = [];
    const publishedCourseMap = {};
    if (courseList) {
      courseList?.course_list?.forEach(item => {
        publishedCourseMap[item?.id] = {
          name: item?.course_name,
          type: item?.course_type,
          actual_duration: item?.duration,
        };
        publishedCourse.push({
          name: item?.id?.toString(),
          label: item?.course_name,
          value: item?.course_name,
          type: item?.course_type,
          actual_duration: item?.duration,
        });
      });
    }
    setCourseListData(publishedCourse);
    setCourseListMap(publishedCourseMap);
  }, [courseList]);

  useEffect(() => {
    const list = [];
    const listMap = {};
    if (assessmentCatlogList?.assessments) {
      assessmentCatlogList?.assessments?.forEach((item: any) => {
        listMap[item?.id] = {
          name: item?.name,
          question: QuestionsTitle + " " + item?.overall_question_count || 0,
          actual_duration: item?.estimated_time,
        };
        list.push({
          name: item?.id?.toString(),
          label: item?.name,
          value: item?.name,
          question: QuestionsTitle + " " + item?.overall_question_count || 0,
          actual_duration: item?.estimated_time,
        });
      });
    }
    setAssesmentCatlog(list);
    setAssesmentCatlogMap(listMap);
  }, [assessmentCatlogList]);

  useEffect(() => {
    setCourses([]);
    setAssessments([]);
    setPreSelectedCoursesIds([]);
    setPreSelectedAssessmentIds([]);
    const assignedCourses = [];
    const assignedCoursesIds = [];
    const assignedAssessments = [];
    const assignedAssessmentIds = [];

    if (learningPlanById) {
      const addedDomain = [];
      const addedRoles = [];
      if (Object.keys(domainListMap)?.length > 0) {
        learningPlanById?.domains?.map(item => {
          addedDomain.push({
            name: item?.id?.toString(),
            value: domainListMap[item.id],
            label: domainListMap[item.id],
          });
        });
      }

      if (Object.keys(jobRoleListMap)?.length > 0) {
        learningPlanById?.job_role_id?.map((item: any) => {
          addedRoles.push({
            name: item?.toString(),
            value: jobRoleListMap[item],
            label: jobRoleListMap[item],
          });
        });
      }

      setBasicInputFormValue({
        learning_plan_name: learningPlanById?.name,
        domain: addedDomain,
        job_role: addedRoles,
        duration: learningPlanById?.duration,
        level:
          learningPlanById?.level_id && learningPlanById?.level_id !== null
            ? learningPlanById?.level_id?.toString()
            : "",
        thumbnail_url: learningPlanById?.thumbnail_url,
        description: learningPlanById?.description,
        auto_assign: learningPlanById?.auto_assign === "True" ? true : false,
        opt_in:
          learningPlanById?.opt_in &&
          learningPlanById?.opt_in !== null &&
          learningPlanById?.opt_in !== ""
            ? true
            : false,
      });

      if (Object.keys(courseListMap)?.length > 0) {
        learningPlanById?.courses?.map((item: any) => {
          assignedCoursesIds.push(item?.id?.toString());
          assignedCourses.push({
            id: item?.id?.toString(),
            mode: courseListMap?.[item?.id]?.type || item?.type,
            title: courseListMap?.[item?.id]?.name || item?.name,
            isMandatory:
              item?.is_mandatory === "True" || item?.is_mandatory === true
                ? true
                : false,
            duration: item?.duration,
          });
        });
      }

      if (Object.keys(assesmentCatlogMap)?.length > 0) {
        learningPlanById?.assessments?.map((item: any) => {
          assignedAssessmentIds.push(item?.id?.toString());
          assignedAssessments.push({
            id: item?.id?.toString(),
            mode: assesmentCatlogMap?.[item?.id]?.question,
            title: assesmentCatlogMap?.[item?.id]?.name,
            isMandatory:
              item?.is_mandatory === "True" || item?.is_mandatory === true
                ? true
                : false,
            duration: assesmentCatlogMap?.[item?.id]?.actual_duration,
          });
        });
      }

      setCourses(assignedCourses);
      setAssessments(assignedAssessments);
      setPreSelectedCoursesIds(assignedCoursesIds);
      setPreSelectedAssessmentIds(assignedAssessmentIds);
    }
  }, [
    learningPlanById,
    courseListMap,
    assesmentCatlogMap,
    jobRoleListMap,
    domainListMap,
  ]);

  const renderButtonText = () => {
    if (showFinish || pageType !== "") {
      return Done;
    } else {
      return Next;
    }
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const validateAllFields = (): boolean => {
    const newErrors: FormErrors = {};
    let isValid = true;

    if (
      !basicInputFormValue?.learning_plan_name ||
      basicInputFormValue?.learning_plan_name === ""
    ) {
      newErrors["learning_plan_name"] = LearningPlanNameRequired;
      isValid = false;
    }

    if (
      !basicInputFormValue?.domain ||
      basicInputFormValue?.domain?.length === 0
    ) {
      newErrors["domain"] = DomainIsRequired;
      isValid = false;
    }

    if (
      (!basicInputFormValue?.job_role ||
        basicInputFormValue?.job_role?.length === 0) &&
      basicInputFormValue?.auto_assign
    ) {
      newErrors["job_role"] = JobRoleIsRequired;
      isValid = false;
    }

    if (!basicInputFormValue?.duration) {
      newErrors["duration"] = DurationIsRequired;
      isValid = false;
    }

    if (
      !basicInputFormValue?.thumbnail_url ||
      basicInputFormValue?.thumbnail_url === "" ||
      basicInputFormValue?.thumbnail_url === null
    ) {
      newErrors["thumbnail_url"] = ThumbnailRequired;
      isValid = false;
    }

    if (
      !basicInputFormValue?.description ||
      basicInputFormValue?.description === ""
    ) {
      newErrors["description"] = DescriptionValidationMessage;
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const uploadFile = async documents => {
    const postData = new FormData();
    documents?.forEach(file => {
      postData.append("files", file);
    });
    const response = await dispatch(
      uploadFileApi({ content: postData, key: fileUrlKeys?.thumbnails })
    );
    return response?.payload?.data?.file_urls;
  };

  const handleNextClick = async () => {
    if (!showFinish && pageType === "") {
      const validated = validateAllFields();
      if (!validated) {
        showToast(PleaseProvideRequiredInformation, "error");
        scrollToTop();
        return;
      }

      dispatch(handlePlanNextButton());
    }
    if (pageType === "details") {
      const validated = validateAllFields();
      if (!validated) {
        showToast(PleaseProvideRequiredInformation, "error");
        scrollToTop();
        return;
      }

      await onSubmitData();
    }
    if (pageType === "people") {
      await onSubmitData();
    }
    if (showFinish && pageType === "") {
      toggleModal();
    }
    scrollToTop();
  };

  const handleNavigate = () => {
    if (domainId) {
      return navigate(
        `${process.env.PUBLIC_URL}/master-data/active-learning-plans?id=${domainId}`
      );
    }
    return navigate(
      `${process.env.PUBLIC_URL}/master-data/learning-plan-detail?id=${learningPlanId}`
    );
  };

  const countCourseTypes = courses => {
    const counts = { ilt: 0, vilt: 0, webinar: 0, wbt: 0 };

    courses?.forEach(({ mode }) => {
      if (counts[mode] !== undefined) counts[mode]++;
    });

    return [
      { label: Courses, value: courses.length },
      { label: courseTypeMap.ilt, value: counts.ilt, key: ILT },
      { label: courseTypeMap.vilt, value: counts.vilt, key: VILT },
      { label: courseTypeMap.webinar, value: counts.webinar, key: WEBINAR },
      { label: courseTypeMap.wbt, value: counts.wbt, key: WBT },
    ];
  };

  const totalDuration = [...courses, ...assessments]?.reduce(
    (total, course) => {
      return (
        total +
          (course.duration || course.duration === 0
            ? course.duration
            : course.actual_duration || 0) || 0
      );
    },
    0
  );

  const onSubmitData = async () => {
    if (courses?.length === 0) {
      showToast(AddCourseAssessment, "error");
      return;
    }

    let uploadedFile = "";

    if (
      basicInputFormValue?.thumbnail_url &&
      basicInputFormValue?.thumbnail_url instanceof File
    ) {
      uploadedFile = await uploadFile([basicInputFormValue?.thumbnail_url]);
    } else {
      uploadedFile =
        fileUrlKeys?.thumbnails +
        "/" +
        extractFileName(basicInputFormValue?.thumbnail_url);
    }

    const updatedCourses = [];
    const updatedAssessments = [];

    courses?.map(item => {
      updatedCourses.push({
        id: item?.id,
        duration: !learningPlanId
          ? item.actual_duration
          : item.duration
            ? item.duration
            : item.actual_duration || 0,
        is_mandatory: item?.isMandatory,
      });
    });

    assessments?.map(item => {
      updatedAssessments.push({
        id: item?.id,
        duration: !learningPlanId
          ? item.actual_duration
          : item.duration
            ? item.duration
            : item.actual_duration || 0,
        is_mandatory: item?.isMandatory,
      });
    });

    const payload: any = {
      name: basicInputFormValue?.learning_plan_name,
      domain_id:
        basicInputFormValue?.domain?.map(item => {
          return Number(item?.name);
        }) || [],
      job_role_id:
        basicInputFormValue?.job_role?.map(item => {
          return Number(item?.name);
        }) || [],
      level_id: basicInputFormValue?.level || null,
      thumbnail_url:
        basicInputFormValue?.thumbnail_url instanceof File
          ? uploadedFile?.[0]
          : uploadedFile || "",
      duration: Number(basicInputFormValue?.duration),
      description: basicInputFormValue?.description,
      auto_assign: basicInputFormValue?.auto_assign || false,
      opt_in: basicInputFormValue?.opt_in || false,
      courses: updatedCourses,
      assessments: updatedAssessments,
    };

    let res = null;
    if (learningPlanId) {
      payload.id = learningPlanId;
      res = await dispatch(
        updateLearningPlan({
          payload: payload,
          type: "edit_learning_plan_details",
        })
      );
    } else {
      res = await dispatch(createLearningPlan({ payload: payload }));
    }

    if (res?.payload?.status_code === STATUS_200) {
      handleNavigate();
    }
  };

  return (
    <div className="page-body pb-5">
      <CommonModal
        sizeTitle={ConfirmCreateLearningPlanHeader}
        isOpen={isModalOpen}
        toggle={toggleModal}
        backdrop="static"
        size="lg"
        showFooter
        onPrimaryBtnClick={onSubmitData}
        primaryBtnText={Confirm}
      >
        {ConfirmCreateLearningPlanBody}
      </CommonModal>
      <Card>
        <CardHeader>
          <H4 className="mt-2">
            {learningPlanId ? ModifyLearningPlan : CreateLearningPlan}
          </H4>
        </CardHeader>
        <CardBody>
          <div className="basic-wizard important-validation">
            {pageType === "" && (
              <StepperHorizontal
                data={learningPlanStepperData}
                level={numberLevel}
              />
            )}
            <div>
              {numberLevel === 1 &&
                (pageType === "" || pageType === "details") && (
                  <LearningPlanBasicDetails
                    domainListData={domainListData}
                    jobRoleListData={jobRoleListData}
                    basicInputFormValue={basicInputFormValue}
                    setBasicInputFormValue={setBasicInputFormValue}
                    errors={errors}
                    setErrors={setErrors}
                    learningPlanId={learningPlanId}
                  />
                )}
              {numberLevel === 2 &&
                (pageType === "" || pageType === "people") && (
                  <AddCoursesOrAssessment
                    courses={courses}
                    setCourses={setCourses}
                    assessments={assessments}
                    setAssessments={setAssessments}
                    preSelectedCoursesIds={preSelectedCoursesIds}
                    setPreSelectedCoursesIds={setPreSelectedCoursesIds}
                    preSelectedAssessmentIds={preSelectedAssessmentIds}
                    setPreSelectedAssessmentIds={setPreSelectedAssessmentIds}
                    courseListData={courseListData}
                    assesmentCatlog={assesmentCatlog}
                    domainListData={domainListData}
                  />
                )}
            </div>
          </div>
        </CardBody>
      </Card>
      <FixedFooter>
        {numberLevel === 2 && (
          <div className="d-flex gap-3 mt-2">
            {countCourseTypes(courses).map(item => (
              <>
                <StatusDisplay label={item.label} number={item.value} />
              </>
            ))}
            <div className="divider"></div>
            <div className="me-2">
              <StatusDisplay
                label={Assessment}
                number={assessments.length.toString()}
              />
            </div>
            <div className="divider"></div>
            <div className="me-2">
              <StatusDisplay
                label={TotalActivityDuration}
                number={formatMinutes(totalDuration)}
              />
            </div>
          </div>
        )}
        <div className="wizard-footer d-flex gap-3 justify-content-end">
          {numberLevel > 1 && pageType === "" && (
            <Btn
              outline
              className="alert-light-primary"
              color="primary"
              onClick={() => {
                scrollToTop();
                dispatch(handleBackButton());
              }}
            >
              {Back}
            </Btn>
          )}
          {pageType !== "" && (
            <Btn
              outline
              className="alert-light-primary"
              color="primary"
              onClick={handleNavigate}
            >
              {Close}
            </Btn>
          )}
          <Btn color="primary" onClick={handleNextClick}>
            {renderButtonText()}
          </Btn>
        </div>
      </FixedFooter>
    </div>
  );
};

export default CreateLearningPlans;
